import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProductRequestReview_interface } from 'src/app/Interface/ProductRequestReview_interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductRequestReviewService {

  constructor(private http: HttpClient) { }

  GetActiveList(Token:String,id:number):Observable<Array<ProductRequestReview_interface>>{
    return this.http.get(environment.BaseUrl + "Daro/ProductRequest/GetActiveListEvalute?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as Array<ProductRequestReview_interface>
      })
    )
  }

  SubmitEvalute(model: Array<ProductRequestReview_interface>,Token:String,id:number):Observable<ProductRequestReview_interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_Model = []
    for (let item of model)
    {
      Local_Model.push({
        review_id:item.id,
        answer:item.dsc,
      })
    }

    var body = {
      id:Number(id),
      token:Token,
      model:Local_Model
    }


      return this.http.post(environment.BaseUrl + "Daro/ProductRequest/SubmitEvalute",body,{headers}).pipe(
        map(data=>{
          return data as ProductRequestReview_interface
        })
      )

  }


}
